import * as React from "react"

import { cn } from "@/lib/utils"
import { DateInput } from "@/components/ui/date-input"
import { NumberInput } from "@/components/ui/number-input"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  if (type === "date") return <DateInput ref={ref} className={className} {...props} />;      // dd/mm/yyyy everywhere; the value stays yyyy-mm-dd
  if (type === "number") return <NumberInput ref={ref} className={className} {...props} />;  // no letters, e/E/+, unwanted minus or extra decimals
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
